module.exports = __webpack_public_path__ + "img/law-explore.55b0ef32.jpg";